var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"phone-audio-bars",style:({height: _vm.height, width: _vm.calcWidth})},_vm._l((_vm.heights),function(factor,i){return _c('rect',{key:i,attrs:{"rx":"4","height":_vm.height*factor,"width":"3","x":i*6,"y":_vm.height/2-(factor*_vm.height/2),"fill":_vm.fillColor(i)}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }